import { FC } from "react";

import { Unauthenticated } from "./Unauthenticated";
import { Authenticated } from "./Authenticated";

interface PagesI {
	auth: boolean;
}

export const Pages: FC<PagesI> = ({ auth }) => {
	if (!auth) {
		return <Unauthenticated />;
	}

	return <Authenticated />;
};
